(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.closeButton = this.querySelector('.cart-drawer__close');

          this.closeButton?.addEventListener('click', () => this.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
          this.dialog?.addEventListener('cancel', () => this.close());
        }

        open() {
          if (this.dialog && !this.dialog.open) this.dialog.showModal();
        }

        close() {
          if (this.dialog?.open) this.dialog.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-reconciler')) {
    customElements.define(
      'cart-reconciler',
      class CartReconciler extends HTMLElement {
        connectedCallback() {
          // Guards against a reload loop if a removal request ever fails to
          // actually resolve the conflict — only ever attempt this once per
          // session before giving up and leaving the cart as-is.
          if (sessionStorage.getItem('cartReconcileInProgress') === 'true') {
            console.error(
              'Cart still has more than one membership tier after a reconciliation attempt — skipping further automatic changes.'
            );
            return;
          }
          sessionStorage.setItem('cartReconcileInProgress', 'true');
          this.reconcile();
        }

        async reconcile() {
          const keys = (this.dataset.removeKeys || '')
            .split(',')
            .map((key) => key.trim())
            .filter(Boolean);
          if (keys.length === 0) return;

          for (const key of keys) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 }),
            });
          }

          if (this.dataset.swapMessage) {
            sessionStorage.setItem('cartSwapMessage', this.dataset.swapMessage);
          }
          window.location.reload();
        }
      }
    );
  }

  if (!customElements.get('cart-page-form')) {
    customElements.define(
      'cart-page-form',
      class CartPageForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        async onSubmit(event) {
          // The Checkout button needs a real navigation — only the Update
          // button's submit is intercepted here for an AJAX quantity update.
          if (event.submitter && event.submitter.name === 'checkout') return;
          event.preventDefault();

          const updates = {};
          this.querySelectorAll('.cart-page__quantity-input').forEach((input) => {
            const match = input.name.match(/^updates\[(.+)\]$/);
            if (match) updates[match[1]] = Number(input.value) || 0;
          });

          try {
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates, sections: 'main', sections_url: window.location.pathname }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || 'Cart update failed');

            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { itemCount: data.item_count } })
            );

            if (data.sections && data.sections.main) {
              const parsed = new DOMParser().parseFromString(data.sections.main, 'text/html');
              const newPage = parsed.querySelector('.cart-page');
              const oldPage = document.querySelector('.cart-page');
              if (newPage && oldPage) oldPage.replaceWith(newPage);
            }
          } catch (error) {
            console.error(error);
            this.showError(error.message);
          }
        }

        // Same "maximum quantity" interception as blocks/membership-tier.liquid
        // — Shopify's generic message doesn't read naturally for a
        // subscription tier, so swap in one that does.
        showError(message) {
          const plugOverlay = document.querySelector('plug-in-overlay');
          if (!plugOverlay) return;

          if (message && /maximum quantity/i.test(message)) {
            plugOverlay.showToast(
              plugOverlay.dataset.quantityLimitTemplate ||
                "You're already plugging in! You have a Membership in your cart waiting for checkout."
            );
            return;
          }

          plugOverlay.showToast(this.dataset.errorText);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-toggle]')) {
      document.querySelector('cart-drawer')?.open();
    }
  });

  document.addEventListener('cart:updated', (event) => {
    const badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    const count = event.detail?.itemCount ?? 0;
    badge.textContent = count;
    badge.hidden = count === 0;
  });

  (() => {
    const sentinel = document.querySelector('.header__sentinel');
    const header = document.querySelector('.header');
    const spacer = document.querySelector('.header__spacer');
    if (!sentinel || !header || !spacer) return;

    // Keeps anchor-link scrolling (#vault, #how, #pricing, back/forward
    // with a hash, etc.) from landing partway under the fixed header.
    const setHeaderHeightVar = () => {
      document.documentElement.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
    };
    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);

    const observer = new IntersectionObserver(
      ([entry]) => {
        const pinning = !entry.isIntersecting;
        if (pinning) {
          spacer.style.height = `${header.getBoundingClientRect().height}px`;
        }
        header.classList.toggle('header--pinned', pinning);
        if (!pinning) {
          spacer.style.height = '0px';
        }
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plug-in-overlay"]) return;
  try {
    
  if (!customElements.get('plug-in-overlay')) {
    customElements.define(
      'plug-in-overlay',
      class PlugInOverlay extends HTMLElement {
        connectedCallback() {
          this.overlay = this.querySelector('.plug-overlay');
          this.toast = this.querySelector('.plug-toast');
          this.toastText = this.querySelector('.plug-toast__text');
          this.toastTimer = null;

          this.overlay.addEventListener('click', () => this.dismissOverlay());

          // The /cart page reconciles conflicting memberships by removing
          // one and reloading (see sections/cart.liquid) — it stashes the
          // swap message here so it still shows up after the reload.
          sessionStorage.removeItem('cartReconcileInProgress');
          const pendingMessage = sessionStorage.getItem('cartSwapMessage');
          if (pendingMessage) {
            sessionStorage.removeItem('cartSwapMessage');
            this.showToast(pendingMessage);
          }
        }

        showOverlay() {
          // Force a reflow so the entrance keyframes always replay, even if
          // triggered again before a previous cycle fully settled.
          this.overlay.hidden = true;
          void this.overlay.offsetWidth;
          this.overlay.hidden = false;
        }

        dismissOverlay() {
          this.overlay.hidden = true;
        }

        // `onHidden`, if given, fires once the toast has fully faded out.
        // Useful for callers that also want to open the cart drawer — a
        // native <dialog> renders in the browser's top layer with its own
        // backdrop, which would otherwise dim this toast if both were
        // visible at the same time.
        showToast(message, onHidden) {
          this.toastText.textContent = message;
          this.toast.hidden = false;
          this.toast.classList.remove('is-visible');
          void this.toast.offsetWidth;
          this.toast.classList.add('is-visible');

          clearTimeout(this.toastTimer);
          this.toastTimer = setTimeout(() => {
            this.toast.classList.remove('is-visible');
            setTimeout(() => {
              this.toast.hidden = true;
              if (onHidden) onHidden();
            }, 300);
          }, 2600);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
